/** AppHQ mark: the white "layers" glyph on a blue rounded tile (matches assets/icon). */
export function AppHQLogo({ size = 72 }: { size?: number }) {
  const r = Math.round(size * 0.223);
  return (
    <div
      aria-hidden
      style={{
        width: size,
        height: size,
        borderRadius: r,
        background: "linear-gradient(180deg, #2a95ff, #0a84ff)",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,.35), 0 10px 24px rgba(10,132,255,.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "0 0 auto",
      }}
    >
      <svg
        viewBox="0 0 24 24"
        width={size * 0.56}
        height={size * 0.56}
        fill="none"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 3 3 8l9 5 9-5-9-5z" />
        <path d="m3 13 9 5 9-5" />
        <path d="m3 18 9 5 9-5" opacity=".55" />
      </svg>
    </div>
  );
}
